

























import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import SwTableHeader from './sw-table-header.vue';
import SwTableBody from './sw-table-body.vue';
import SwTable from './sw-table.vue'; // only for types
import { utilService } from './util.service';
import {
  TableColumnConfig,
  TableHeaderMetrics,
} from './types';
import { CSSStyleOptions } from '../common-types';

const cssPrefix = 'sw-table-fixed-portion';

@Component({
  components: {
    SwTableBody,
    SwTableHeader,
  },
})
export default class SwTableFixedPortion extends SwExtendedVue {
  @Prop({ type: String, required: true })
  side: 'left' | 'right';

  @Prop({ type: Array, required: true })
  portionColumnsConfig: TableColumnConfig[];

  @Prop({ type: Boolean, required: true })
  showHeader: boolean;

  @Prop({ type: Object, required: true })
  headerMetrics: TableHeaderMetrics;

  @Prop({ type: Object, required: true })
  originalHeaderProps: SwTable['headerProps'];

  @Prop({ type: Object, required: true })
  originalBodyProps: SwTable['bodyProps'];

  cssPrefix = cssPrefix;

  /** we need to recalculate the effectiveColumnsConfig for fixed portion */
  get effectiveColumnsConfig(): TableColumnConfig[] {
    return this.portionColumnsConfig.slice(0);
  }

  get headerProps() {
    return Object.assign({}, this.originalHeaderProps, {
      columnsConfig: this.portionColumnsConfig,
      effectiveColumnsConfig: this.effectiveColumnsConfig,
      forFixedPortion: true,
    });
  }

  get bodyProps() {
    return Object.assign({}, this.originalBodyProps, {
      columnsConfig: this.portionColumnsConfig,
      effectiveColumnsConfig: this.effectiveColumnsConfig,
      forFixedPortion: this.side,
    });
  }

  get wrapperStyle(): CSSStyleOptions {
    const width = utilService.calcTableWidth(this.effectiveColumnsConfig);
    return {
      width: `${width}px`,
      height: `${this.originalHeaderProps.bodyMetrics.clientHeight! + (this.showHeader ? this.headerMetrics.clientHeight! : 0)}px`,
    };
  }

  public updateBodyPosition(param: { top: number }) {
    (this.$refs.body as SwTableBody).updatePosition(param);
  }
}
